import { Grid, Typography } from "@mui/material";
import { SettingsRowChevron } from "Components/Settings/SettingsItem/SettingsRowChevron";

import type { JSX, ReactNode } from "react";

type Props = {
  onClick: () => void;
  text: string;
  icon: JSX.Element;
  isBottomBorderHidden?: boolean;
  isChevronHidden?: boolean;
};

export const SettingsRowButton = ({
  onClick,
  text,
  icon,
  isBottomBorderHidden,
  isChevronHidden,
}: Props) => (
  <ContainerButton
    onClick={onClick}
    isBottomBorderHidden={isBottomBorderHidden}
  >
    <Grid
      size={{ xs: 1 }}
      display="flex"
      sx={{ svg: { height: "16px", width: "16px" } }}
    >
      {icon}
    </Grid>
    <Grid size={{ xs: 10 }}>
      <Typography fontSize={16} textAlign="left">
        {text}
      </Typography>
    </Grid>
    <Grid size={{ xs: 1 }} justifyContent="flex-end" display="flex">
      {!isChevronHidden && <SettingsRowChevron />}
    </Grid>
  </ContainerButton>
);

type ContainerButtonProps = {
  children: ReactNode;
  onClick: () => void;
  isBottomBorderHidden?: boolean;
};

const ContainerButton = ({
  children,
  onClick,
  isBottomBorderHidden = false,
}: ContainerButtonProps) => (
  <Grid
    container
    component="button"
    onClick={onClick}
    sx={({ palette, spacing }) => ({
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      border: "none",
      background: "none",
      cursor: "pointer",
      m: 0,
      p: spacing(4, 0),
      color: palette.text.secondary,
      borderBottom: isBottomBorderHidden
        ? "none"
        : `1px solid ${palette.divider}`,
    })}
  >
    {children}
  </Grid>
);
